import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

// scroll bar script
$(window).on('load',function(){
  if($('.js-tabsBlock') && $(window).width() > 1025) {
     $('.js-tabsBlock').mCustomScrollbar({
      callbacks:{
        whileScrolling: function(){
          if(this.mcs.topPct > 90) {
            this.classList.add('not-gradient')
          } else {
            this.classList.remove('not-gradient')
          }
        }
      }
    });
  }
});

//estate tabs
$('.js-estateTab').on('click', function() {
  if(!$(this).hasClass('is-active')) $(this).addClass('is-active').siblings().removeClass('is-active')

  const tabContent = $(this).parents('.js-tabsWrap').find('.js-estateTabContent').eq($(this).index())
  const tabTitle = $(this).text()


  tabContent.fadeIn(1000).siblings().hide()
  tabContent.find('.js-tabsShow').text(tabTitle)

  if($(window).width() < 1025) {
    $(this).parents('.js-tabsBlock').removeClass('is-show')
    enableBodyScroll('body')
  }
})

$('.js-tabsShow').on('click', function() {
  $(this).parents('.js-tabsWrap').find('.js-tabsBlock').addClass('is-show')
  disableBodyScroll('body')
})

$('.js-tabsClose').on('click', function() {
  $(this).parents('.js-tabsBlock').removeClass('is-show')
  enableBodyScroll('body')
})

$('.js-projectsLink').on('click', function() {
  var headerHeight = $('.header').height();
  var projectsTop = $('#projects').offset().top - headerHeight;
  $('html, body').animate({scrollTop: projectsTop}, 1000)
})
